import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  // 切换下拉菜单
  toggle(event) {
    const button = event.currentTarget
    const dropdownId = button.getAttribute('data-dropdown-id')
    const targetDropdown = document.getElementById(dropdownId)
    const icon = button.querySelector('svg')

    if (!targetDropdown) return

    const isHidden = targetDropdown.classList.contains('hidden')

    // 如果当前下拉菜单已经显示，则关闭它
    if (!isHidden) {
      this.collapseDropdown(targetDropdown, icon)
      return
    }

    // 检查是否有其他菜单已经打开
    const hasOpenDropdown = this.dropdownTargets.some(dropdown =>
      !dropdown.classList.contains('hidden') && dropdown !== targetDropdown
    )

    // 关闭所有下拉菜单并重置所有图标
    this.dropdownTargets.forEach(dropdown => {
      if (!dropdown.classList.contains('hidden')) {
        const dropdownButton = document.querySelector(`[data-dropdown-id="${dropdown.id}"]`)
        const dropdownIcon = dropdownButton ? dropdownButton.querySelector('svg') : null
        // 如果有其他菜单打开，直接隐藏；否则使用收起动画
        if (hasOpenDropdown) {
          this.hideDropdown(dropdown, dropdownIcon)
        } else {
          this.collapseDropdown(dropdown, dropdownIcon)
        }
      }
    })

    // 如果有其他菜单打开，直接显示新菜单；否则使用展开动画
    if (hasOpenDropdown) {
      this.showDropdown(targetDropdown, icon)
    } else {
      this.expandDropdown(targetDropdown, icon)
    }
  }

  // 直接显示下拉菜单（无动画）
  showDropdown(dropdown, icon) {
    dropdown.classList.remove('hidden')
    dropdown.style.maxHeight = '460px'

    if (icon) {
      icon.classList.add('rotate-180')
    }
  }

  // 直接隐藏下拉菜单（无动画）
  hideDropdown(dropdown, icon) {
    dropdown.classList.add('hidden')
    dropdown.style.maxHeight = ''
    dropdown.style.overflow = ''
    dropdown.style.transition = ''

    if (icon) {
      icon.classList.remove('rotate-180')
    }
  }

  // 展开下拉菜单（带动画）
  expandDropdown(dropdown, icon) {
    dropdown.classList.remove('hidden')
    dropdown.style.overflow = 'hidden'
    dropdown.style.maxHeight = '0px'
    dropdown.style.transition = 'max-height 0.3s ease-out'

    // 计算目标高度，限制在 460px 内
    const maxAllowedHeight = 460
    const targetHeight = Math.min(dropdown.scrollHeight, maxAllowedHeight)

    // 强制浏览器重绘，然后展开
    setTimeout(() => {
      dropdown.style.maxHeight = targetHeight + 'px'
    }, 10)

    // 动画结束后清理样式，但保持 maxHeight
    setTimeout(() => {
      dropdown.style.maxHeight = maxAllowedHeight + 'px'
      dropdown.style.overflow = ''
      dropdown.style.transition = ''
    }, 310)

    if (icon) {
      icon.classList.add('rotate-180')
    }
  }

  // 收起下拉菜单（带动画）
  collapseDropdown(dropdown, icon) {
    // 获取当前的实际高度（可能已经设置了 maxHeight）
    const currentHeight = dropdown.offsetHeight
    dropdown.style.maxHeight = currentHeight + 'px'
    dropdown.style.overflow = 'hidden'
    dropdown.style.transition = 'max-height 0.3s ease-out'

    // 强制浏览器重绘，然后收起
    setTimeout(() => {
      dropdown.style.maxHeight = '0px'
    }, 10)

    // 动画结束后添加 hidden 类
    setTimeout(() => {
      dropdown.classList.add('hidden')
      dropdown.style.maxHeight = ''
      dropdown.style.overflow = ''
      dropdown.style.transition = ''
    }, 310)

    if (icon) {
      icon.classList.remove('rotate-180')
    }
  }

  // 关闭所有下拉菜单
  closeAll() {
    this.dropdownTargets.forEach(dropdown => {
      if (!dropdown.classList.contains('hidden')) {
        const dropdownButton = document.querySelector(`[data-dropdown-id="${dropdown.id}"]`)
        const dropdownIcon = dropdownButton ? dropdownButton.querySelector('svg') : null
        this.collapseDropdown(dropdown, dropdownIcon)
      }
    })
  }
}

